import { State } from '../../@types/state';

export const selectInitFetch = (state: State): boolean => {
  return state.line.initFetch;
};

export const selectFetchPending = (state: State): boolean => {
  return state.line.pending;
};
